import i18n from "@/i18n.ts";
import { useAuthStore } from "@/stores/employee.store.ts";
import { DefaultChatTransport } from "ai";

export function createAiAssistantTransport(threadId?: number) {
  let currentThreadId = threadId;
  const api = new URL("/api/v1/ai-assistant/chat", import.meta.env.VITE_BASE_API).toString();
  return {
    transport: new DefaultChatTransport({
      api,
      headers: () => {
        const { token, userId } = useAuthStore.getState();
        const headers: Record<string, string> = { "X-Language": i18n.language };
        if (token) headers.Authorization = `Bearer ${token}`;
        if (userId) headers["X-User-Id"] = userId.toString();
        return headers;
      },
      // Читается на каждый запрос: автоотправка после подтверждения повторяет опции первого хода без thread_id.
      body: () => ({ thread_id: currentThreadId }),
      prepareReconnectToStreamRequest: ({ headers }) => ({
        api: `${api}/${currentThreadId}/stream`,
        headers,
      }),
    }),
    getThreadId: () => currentThreadId,
    setThreadId: (id: number) => {
      currentThreadId = id;
    },
  };
}

// DefaultChatTransport кладёт тело ответа с ошибкой в message.
export function isAiAssistantLimitError(error: Error): boolean {
  try {
    return JSON.parse(error.message)?.error?.code === "ai_assistant_limit_exceeded";
  } catch {
    return false;
  }
}

export function isAiAssistantBusyError(error: Error): boolean {
  try {
    const validationErrors: { code: string }[] =
      JSON.parse(error.message)?.error?.validation_errors ?? [];
    return validationErrors.some(({ code }) => code === "ai_assistant_reply_in_progress");
  } catch {
    return false;
  }
}
